import { KYMW0900Model } from "../kymw0900.model";
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from "src/app/shared/vo/pless-request.model";

// レスポンス構造
export interface GetPlanGoodsPointExchangePromotionResponse {
  /** ポイント交換商品プロモーションフラグ */
  PointPromotionFlg: string;
  /** ポイント交換商品情報リスト */
  PointExchangeList: {
    /** アイテムコード */
    ItemCode: string;
    /** ポイント交換注文番号割当コード */
    PointExchangeOrderNumQuotaCode: string;
    /** ポイント交換注文番号 */
    PointExchangeOrderNum: number;
    /** 専用商品名 */
    PointExchangeGoodsName: string;
    /** 専用商品名（カナ） */
    PointExchangeGoodsNameKana: string;
    /** 専用規格名 */
    PointExchangeGuideName: string;
    /** 専用規格名（カナ） */
    PointExchangeGuideNameKana: string;
    /** ポイント不足エラー区分 */
    ShortOfPointDiv: number;
    /** ECのみフラグ */
    EcOnlyFlg: string;
    /** 消費税率 */
    ConsumeTaxRate: string;
    /** 会員生協別ポイント一覧 */
    CoopPointRateList: {
      /** アイテムコード */
      ItemCode: string;
      /** 生協コード */
      CoopCode: string;
      /** 今回供給価格 */
      ThisTimeSupplyPrice: number;
      /** ポイント率 */
      PointRate: string;
      /** 交換ポイント（税抜） */
      PointExchangeEquivalentAmount: string;
      /** 交換ポイント */
      ExchangePoints: string;
    }[];
  }[];
}

/**
 * ポイント交換商品プロモーション情報取得サービス
 *
 * @export PlanGoodsPointExchangePromotionService
 * @class PlanGoodsPointExchangePromotionService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class PlanGoodsPointExchangePromotionService extends PlessJsonResponderSub<any> {

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof PlanGoodsPointExchangePromotionService
   */
  private successFunc: Function;

  model: KYMW0900Model;

  vo = {
    orderCode: '',
    pCode: '',
  };

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof PlanGoodsPointExchangePromotionService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        PCodeCommon: {
          condition: {
            OrderCode: this.vo.orderCode,
            PCode: this.vo.pCode
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof PlanGoodsPointExchangePromotionService
   */
  execute(model: any, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getPlanGoodsPointExchangePromotion', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof PlanGoodsPointExchangePromotionService
   */
  success(data: GetPlanGoodsPointExchangePromotionResponse): void {
    if (data !== null) {
      this.model.setPlanGoodsPointExchangePromotion(data);
      this.successFunc(data);
    }
  }
}
